import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex)


export default new Vuex.Store({
	state: {
		name: "",
		nickname: "",
		number: "",
		score: 0,
		score0: 0,
		score1: 0,
		score2: 0,
		score3: 0,
		logined: false,
		summary1: "",
		summary2: "",
		summary3: "",
		summary4: "",
		summary5: "",
		steps1: "",
		steps2: "",
		steps3: "",
	},
	mutations: {
		Logout(state) {
			state.logined = false
		},
		Login(state, payload) {
			state.logined = true
			state.name = payload.name
			state.nickname = payload.nickname
			state.number = payload.number
			state.score = payload.score
			// state.token = payload.token
			// state.User = User
		},
		SetSteps1(state, payload) {
			state.steps1 = payload
		},
		SetSteps2(state, payload) {
			state.steps2 = payload
		},
		SetSteps3(state, payload) {
			state.steps3 = payload
		},
		SetScore0(state, payload) {
			state.score0 = payload
		},
		SetScore1(state, payload) {
			state.score1 = payload.score
		},
		SetScore2(state, payload) {
			state.score2 = payload.score
		},
		SetScore3(state, payload) {
			state.score3 = payload.score
		},
		SetSummary1(state, payload) {
			state.summary1 = payload;
		},
		SetSummary2(state, payload) {
			state.summary2 = payload;
		},
		SetSummary3(state, payload) {
			state.summary3 = payload;
		},
		SetSummary4(state, payload) {
			state.summary4 = payload;
		},
		SetSummary5(state, payload) {
			state.summary5 = payload;
		}
	}
})
